import RuntimeRepository from "./runtime.repository";
import * as R from "ramda";
import { fn } from "util";

class BaseRepository {
  // Resource on this repository is syncable
  // TODO: Transform in method
  syncable = false;

  async prepare() {
    if (this.prepared) {
      return;
    }

    this.mService = await this.getServiceProvider().getInstance();
    this.mRuntime = await RuntimeRepository.getInstance();
    this.mRunningGets = [];
    await this.additionalPrepare();

    this.prepared = true;
  }

  async additionalPrepare() {
    // DO NOTHING;
  }

  async get(uuid) {
    const promise$ = this._internalGet(uuid);
    this.mRunningGets.push(promise$);
    return await promise$;
  }

  _internalGet = R.memoizeWith(fn.timedIdentity(10), async uuid => {
    if (!uuid) {
      return { success: false };
    }

    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const serviceResult = await this.mService.fetchByUuid(
      currentUser.company_uuid,
      uuid
    );

    if (serviceResult.success) {
      serviceResult.data = await this.modelToEntity(serviceResult.data);
    }

    return serviceResult;
  });

  async getOnline(uuid) {
    if (!uuid) {
      return { success: false };
    }

    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    let serviceResult = {};
    if (currentUser) {
      serviceResult = await this.mService.fetchByUuid(
        currentUser.company_uuid,
        uuid
      );
    }

    if (serviceResult.success) {
      serviceResult.data = await this.modelToEntity(serviceResult.data);
    }

    return serviceResult;
  }

  async create(params) {
    const serviceObject = params.getServiceObject
      ? params.getServiceObject()
      : params;
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const serviceResult = await this.mService.create(
      currentUser.company_uuid,
      serviceObject
    );

    if (serviceResult.success) {
      serviceResult.data = await this.modelToEntity(serviceResult.data);
    }

    return serviceResult;
  }

  async update(uuid, params) {
    const serviceObject = params.getServiceObject
      ? params.getServiceObject()
      : params;
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const serviceResult = await this.mService.update(
      currentUser.company_uuid,
      uuid,
      serviceObject
    );

    if (serviceResult.success) {
      serviceResult.data = await this.modelToEntity(serviceResult.data);
    }

    return serviceResult;
  }

  async getListOnline({
    filters = [],
    order = [],
    pagination = { page: 1, perPage: 25 }
  }) {
    const currentUser = await this.mRuntime.get(
      RuntimeRepository.props.currentUser
    );
    const result = await this.mService.fetch(currentUser.company_uuid, {
      filters,
      order,
      pagination
    });

    if (!result.success) {
      return result;
    }
    const entitiesPromises = result.data.map(model =>
      this.modelToEntity(model)
    );
    result.data = await Promise.all(entitiesPromises);
    result.total = result.headers.total;
    result.perPage = result.headers["per-page"];
    return result;
  }

  async findFirst({ filters = [], order = [] }) {
    const result = await this.getListOnline({
      filters,
      order,
      pagination: { page: 1, perPage: 1 }
    });

    if (!result.success) {
      return false;
    }

    const data = result.data;
    return data.length > 0 ? data[0] : false;
  }

  async getAll({ filters }) {
    this.mRunningGets = [];

    const currentUser = await this.mRuntime.get("currentUser");
    const entities = [];
    const result = await this.mService.stream(
      currentUser.company_uuid,
      { filters, checkUserCancellation: true },
      async model => {
        entities.push(await this.modelToEntity(model));
      }
    );

    await Promise.all(this.mRunningGets);

    return {
      success: result.success,
      data: entities,
      userCancelled: result.userCancelled
    };
  }

  async modelToEntity(model) {
    return model;
  }
}

export default BaseRepository;



// WEBPACK FOOTER //
// ./src/core/repository/base.repository.js